export const COVER_LETTER_MIN_LENGTH = 50;

export function getCoverLetterValidationError(
  value: string,
  required: boolean
): string | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return required ? "Escribí una carta de presentación para continuar." : null;
  }
  if (trimmed.length < COVER_LETTER_MIN_LENGTH) {
    return `La carta de presentación debe tener al menos ${COVER_LETTER_MIN_LENGTH} caracteres.`;
  }
  return null;
}
